<script setup>
import eventBus from '@/eventBus';
import { useShopify } from '@/stores/shopify';
import ButtonDefault from '@/components/atoms/ButtonDefault.vue';
import ProductQuantityChanger from './ProductQuantityChanger.vue';

const shopify = useShopify();
const quantity = defineModel();

defineProps({
  variant: {
    type: String,
    required: false,
  },
  available: {
    type: Boolean,
    required: true,
  },
  buyNow: {
    type: Boolean,
    default: true,
  },
  showOnMobile: {
    type: Boolean,
    default: true
  },
  showOnDesktop: {
    type: Boolean,
    default: true
  },
  product: {
    type: Object,
    required: false,
  }
});

const trackProductObj = (product) => {
  return {
    handle: product.handle,
    id: product.id,
    name: product.title,
    price: 1 * (product.priceRange?.minVariantPrice?.amount ?? 0)
  }
}

const addToCart = (variant, quantity, product) => {
  window.trackEvent && window.trackEvent('add_to_cart', product.handle);
  const trackProduct = trackProductObj(product);
  window.ttq && window.ttq.track('AddToCart', {
    "contents": [
      {
        "content_id": trackProduct.handle,
        "content_type": "product",
        "content_name": trackProduct.name
      }
    ],
    "value": trackProduct.price,
    "currency": "EUR"
  });
  // Google Analytics tracking for Add To Cart event
  window.gtag && window.gtag('event', 'add_to_cart', {
    currency: "EUR",
    value: trackProduct.price,
    items: [
      {
        item_id: trackProduct.handle,
        item_name: trackProduct.name,
        price: trackProduct.price,
        quantity: 1,
        currency: "EUR"
      }
    ]
  });
  shopify.addToCart(variant, quantity)
    .then(() => {
      eventBus.$emit('cart-added-items');
    });
};

const fastCheckout = (variant, quantity, product) => {
  //const windowRef = window.open('', '_blank');
  window.trackEvent && window.trackEvent('fast_checkout', product.handle);
  const trackProduct = trackProductObj(product);
  window.ttq && window.ttq.track('InitiateCheckout', {
    "contents": [
      {
        "content_id": trackProduct.handle,
        "content_type": "product",
        "content_name": trackProduct.name
      }
    ],
    "value": trackProduct.price,
    "currency": "EUR"
  });
  
  // Google Analytics tracking for checkout event
  window.gtag && window.gtag('event', 'begin_checkout', {
    currency: "EUR",
    value: trackProduct.price,
    items: [
      {
        item_id: trackProduct.handle,
        item_name: trackProduct.name,
        price: trackProduct.price,
        quantity: quantity,
        currency: "EUR"
      }
    ]
  });
  shopify.fastCheckout(variant, quantity)
    .then((checkoutUrl) => {
      if (checkoutUrl) {
        document.location.href = checkoutUrl;
      }
    });
}
</script>

<template>
  <template v-if="available">
    <ProductQuantityChanger
      v-model="quantity"
      :limitMin="true"
      :showOnMobile="showOnMobile"
      :showOnDesktop="showOnDesktop"
    />
    <ButtonDefault type="colored" v-if="buyNow" @click="fastCheckout(variant, quantity, product)" class="cart-button">Jetzt kaufen</ButtonDefault>
    <ButtonDefault type="dark" v-if="variant" @click="addToCart(variant, quantity, product)" class="cart-button">In den Warenkorb</ButtonDefault>
  </template>
  <ButtonDefault type="white" disabled="true" v-else class="cart-button">Bald wieder verfügbar</ButtonDefault>
</template>

<style lang="scss" scoped>
.cart-button {
  height: 48px;
  font-weight: 600;

  &[disabled] {
    font-weight: 500;
    width: calc(100% - 40px);
    margin-inline: auto;
    border: 2px solid var(--clr-gray-200);
    background: var(--clr-white);
    color: var(--clr-gray-400);
  }
}
</style>